import { Button } from "@chakra-ui/react";
import {
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenu as UI_DropdownMenu,
} from "components/ui/dropdown-menu";
import { toast } from "components/ui/use-toast";
import { IAccountingAccount } from "src/@types/account-accouting";
import Edit from "../../../../../assets/icons/edit";
import { useDialogModal } from "../../../../../hook/handle-modal/hooks/actions";
import { useUpdateAccountingAccountMutation } from "../../../../../services/account-accouting";
import statusFormat from "../../utils/status-format";
import Update from "../../update";
import { MESSAGES } from "../../utils/messages";

function DropdownMenuComponent({
  trigger,
  row,
}: {
  trigger: React.ReactNode;
  row: IAccountingAccount;
}) {
  const { icon, title, updateTo } = statusFormat(row.status);
  const [updateAccountingAccount, { isLoading }] =
    useUpdateAccountingAccountMutation();
  const { handleModal } = useDialogModal();

  const alterStatus = () => {
    try {
      updateAccountingAccount({
        id: row.id,
        name: row.name,
        status: updateTo,
        version: row.version,
      }).unwrap();
      toast(MESSAGES.DISABLED.SUCCESS);
    } catch (err) {
      console.error(err);
      toast(MESSAGES.DISABLED.ERROR);
    }
  };

  const openModalUpdate = () => {
    handleModal({
      isOpen: true,
      element: <Update row={row} />,
      title: "Editar Conta Contábil",
    });
  };

  return (
    <>
      <UI_DropdownMenu>
        {" "}
        <DropdownMenuTrigger asChild>{trigger}</DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem
            style={{ cursor: "pointer" }}
            onClick={() => openModalUpdate()}
          >
            <Button
              variant="link"
              className="pointer flex items-center justify-start gap-4"
            >
              <Edit color={"black"} size={13} />
              Editar
            </Button>
          </DropdownMenuItem>
          <DropdownMenuItem style={{ cursor: "pointer" }} onClick={alterStatus}>
            <Button
              variant="link"
              className="pointer flex items-center justify-start gap-4"
              isLoading={isLoading}
            >
              {icon}
              {title}
            </Button>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </UI_DropdownMenu>{" "}
    </>
  );
}

export default DropdownMenuComponent;
